module.exports = __webpack_public_path__ + "img/mobile-45.2666d855.png";